export default __webpack_public_path__ + "static/joel-90ca0fb15ffd621ec10b67745bfe5752.png";